<template>
  <div class="subview informations">
    <div :class="['field', 'field-radio', { 'has-error': sexError }]">
      <!-- <div
        v-for="sex in sexes"
        :key="`input-${sex.value}`"
        class="field-element"
      >
        <input
          :id="`sex-${sex.value}`"
          :checked="infos.sex === sex.value"
          :value="sex.value"
          type="radio"
          class="u-visually-hidden"
          @change="onInput(sex.value, 'sex')"
        >
        <label :for="`sex-${sex.value}`">{{ sex.label }}</label>
      </div> -->

      <span
        v-if="sexError"
        class="field-error"
      >
        {{ sexError }}
      </span>
    </div>

    <template v-for="field in fields">
      <div
        v-if="field.type === 'select'"
        :key="`field-${field.name}`"
        class="field"
      >
        <label
          :for="`field-${field.name}`"
          class="field-label"
        >
          Pays
        </label>
        <selection
          :id="`field-${field.name}`"
          :options="countries"
          :selected="selectedCountry"
          :placeholder="''"
          @option="onOptionCountry($event)"
        />
      </div>

      <field
        v-else
        :key="`field-${field.name}`"
        :id="field.name"
        :label="field.label"
        :value="infos[field.name]"
        :type="field.type || 'text'"
        :required="field.required"
        :error="field.error"
        @input="onInput($event, field.name)"
      />
    </template>

    <pagination
      :back="true"
      :nextDisable="disableNext"
      @prev="onPrev"
      @next="onNext"
    />
  </div>
</template>

<script>
import Field from '@/components/modules/Field.vue';
import Pagination from '@/components/partials/Pagination.vue';
import Selection from '@/components/components/Selection.vue';
// Data
import profile from '@/data/static/profile.json';
import countries from '@/data/static/countries.json';

export default {
  components: {
    Field,
    Selection,
    Pagination
  },
  beforeMount() {
    if (!this.$store.state.login.logged) {
      this.$store.commit('profile/resetInfos');
    }
  },
  data() {
    return {
      fields: [...profile.fields],
      // sexes: [...basket.informations.sex.answers],
      sexError: null,
      countries
    };
  },
  computed: {
    infos() {
      return this.$store.state.profile.infos;
    },
    disableNext() {
      const { infos } = this.$store.state.profile;
      let disabled = false;

      // if (!infos.sex) {
      //   disabled = true;
      // }

      this.fields.map(field => {
        if (field.required) {
          if (!infos[field.name] || infos[field.name].length === 0) {
            disabled = true;
          }
        }
      });

      return disabled;
    },
    selectedCountry() {
      const { country } = this.$store.state.profile.infos;

      this.defaultSelected();

      const selected = this.countries.filter(c => c.value === country.toUpperCase());

      if (selected && selected.length > 0) {
        return selected[0];
      }
      return this.countries[0];
    }
  },
  methods: {
    defaultSelected() {
      const { country } = this.$store.state.profile.infos;

      if (!country) {
        setTimeout(() => {
          this.$store.state.profile.infos.country = 'be';
        }, 500);

        return this.countries[0];
      }
      return this.countries[0];
    },
    validate() {
      let valid = true;

      // Sex
      // if (!this.infos.sex) {
      //   this.sexError = 'Ce champ est requis';
      //   valid = false;
      // } else {
      //   this.sexError = null;
      // }

      // Fields
      this.fields.map(field => {
        if (field.required) {
          const value = this.infos[field.name];
          if (!value || value.length === 0) {
            // eslint-disable-next-line
            field.error = 'Ce champ est requis';
            valid = false;
          } else {
            // eslint-disable-next-line
            if (field.validation) {
              const regex = new RegExp(field.validation.regex, 'i');
              const match = regex.test(value);

              if (match) {
                field.error = null;
              } else {
                field.error = field.validation.message;
                valid = false;
              }
            } else {
              field.error = null;
            }
          }
        }
        return field;
      });

      return valid;
    },
    // events
    onInput($event, type) {
      this.$store.commit('profile/updateInfo', {
        value: $event,
        type
      });
    },
    onChange($event, type) {
      this.$store.commit('profile/updateInfo', {
        value: $event,
        type
      });
    },
    onOptionCountry($event) {
      this.$store.commit('profile/updateInfo', {
        value: $event.value.toLowerCase(),
        type: 'country'
      });
    },
    onPrev() {
      this.$router.push({ name: 'BasketPlaces' });
    },
    async onNext() {
      const valid = this.validate();

      if (valid) {
        // eslint-disable-next-line
        const create = await this.$store.dispatch('profile/create');
        this.$router.push({ name: 'BasketPayment' });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.subview {
  .field {
    + .field {
      @include margin(16px null null);
    }

    &-label {
      @include padding(null null 10px);
      @include font('primary', 'bold');
      display: block;
      font-size: rem(18px);
      line-height: 1;
    }

    &.field-radio {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;

      &.has-error {
        .field-element label {
          color: $primary;
        }
      }

      // + .field {
      //   @include margin(40px null null);
      // }

      .field-element {
        input:checked {
          + label {
            &::after {
              opacity: 1;
            }
          }
        }

        label {
          @include padding(null null null 24px);
          @include font('secondary', 'regular');
          display: block;
          position: relative;
          font-size: rem(18px);
          line-height: 1;

          &::before {
            @include position(absolute, 0 null null 0);
            @include size(16px);
            content: '';
            border-radius: 50%;
            background-color: $grey-light-alternate;
          }

          &::after {
            @include position(absolute, 0 null null 0);
            @include size(16px);
            content: '';
            border: 5px solid $black;
            border-radius: 50%;
            opacity: 0;
            background-color: $white;
          }
        }
      }

      .field-error {
        @include padding(4px null null);
        width: 100%;
        font-size: rem(14px);
        color: $primary;
      }
    }
  }
}
</style>
